<template>
    <b-card>
        <banner-form :brands="brands" :patterns="patterns" @on-refresh="$emit('on-refresh')"></banner-form>
        <banner-table :brands="brands" :patterns="patterns" :banners="banners" @on-refresh="$emit('on-refresh')"></banner-table>
    </b-card>
</template>

<script>
    import BannerForm from './add-banner-form.vue';
    import BannerTable from './table.vue';
    export default {
        components: {
            BannerForm,
            BannerTable,
        },
        props: {
            brands: {
                type: Array,
                required: true,
            },
            patterns: {
                type: Array,
                required: true,
            },
            banners: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {};
        },
        computed: {},
        methods: {},
    };
</script>

<style></style>
